import Plyr from "plyr"

import getElementsStartWithId from "./utilities"

/**
 * @title Initialise Video Player
 * @description Logic for handling the Video players throughout the DOM
 */
function initialiseVideoPlayer() {
  let videos = getElementsStartWithId("video-player")

  videos.forEach((element) => {
    const player = new Plyr(element, {
      vimeo: { background: true, dnt: true },
    })
  })
}

export default initialiseVideoPlayer
